export default __webpack_public_path__ + "static/media/fresh-wheat-crop.35fd5a36.jpeg";